/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceDataV1 } from './invoiceDataV1';


export interface Invoice { 
    /**
     * The ID of the invoice.
     */
    readonly id: string;
    invoiced_at: string;
    /**
     * Type is the type of the invoice. usage InvoiceTypeUsage base InvoiceTypeBase
     */
    readonly type: Invoice.TypeEnum;
    updated_at?: string;
    v1?: InvoiceDataV1;
}
export namespace Invoice {
    export type TypeEnum = 'usage' | 'base';
    export const TypeEnum = {
        Usage: 'usage' as TypeEnum,
        Base: 'base' as TypeEnum
    };
}


